import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';
import {
  accountListByFilter,
  accountSaveMutation,
} from '../../../shared/queries/Account';
import GraphQL from '../../../GraphQL';
import AccountForm from './Form';
import SmartPayForm from './FormSmartPay';
import SmartCard from '../../../shared/components/SmartCard';

const AccountFormHandler = (props) => {
  const { match, t, history, dispatch } = props;
  const [dto, setDto] = useState({
    id: 0,
    active: true,
    defaultAccount: false,
    checkingAccount: false,
    autoWithDraw: true,
  });
  const [formOn, setFormOn] = useState(false);
  const [formSmartPay, setFormSmartPay] = useState(false);

  function backClickHandler() {
    history.push('/minime/conta');
  }

  function showLoading() {
    dispatch(changeLoadingTrue());
  }

  function hideLoading() {
    dispatch(changeLoadingFalse());
  }

  function findById(id) {
    showLoading();
    const query = accountListByFilter(id);
    GraphQL(query, {})
      .then((res) => {
        if (res.accountListByFilter) {
          if (!res.accountListByFilter[0].smartpay) {
            if (res.accountListByFilter[0].checkingAccount) {
              const account = res.accountListByFilter[0];
              setDto({
                ...account,
                bank: {
                  ...account.bank,
                  id: account.bank.id,
                  value: account.bank.id,
                  label: account.bank.name,
                },
                ownerType: account.ownerType,
              });
            } else {
              setDto({
                ...res.accountListByFilter[0],
                bank: { label: t('account.placeholders.select') },
              });
            }
          } else {
            const smartpayAccount = { ...res.accountListByFilter[0] };
            setDto({
              ...smartpayAccount,
              ...smartpayAccount.iuguAccountInfo,
              cnpj: smartpayAccount.iuguAccountInfo.cnpj
                ? smartpayAccount.iuguAccountInfo.cnpj.replace(/[.,/-]/g, '')
                : smartpayAccount.iuguAccountInfo.cnpj,
              respCpf: smartpayAccount.iuguAccountInfo.respCpf
                ? smartpayAccount.iuguAccountInfo.respCpf.replace(/[.,/-]/g, '')
                : smartpayAccount.iuguAccountInfo.respCpf,
              bank: {
                ...smartpayAccount.iuguAccountInfo.bank,
                id: smartpayAccount.iuguAccountInfo.bank
                  ? smartpayAccount.iuguAccountInfo.bank.id
                  : 0,
                value: smartpayAccount.iuguAccountInfo.bank
                  ? smartpayAccount.iuguAccountInfo.bank.id
                  : 0,
                label: smartpayAccount.iuguAccountInfo.bank
                  ? t(`${smartpayAccount.iuguAccountInfo.bank.name}`)
                  : '',
              },
              zipCode: smartpayAccount.iuguAccountInfo.cep
                ? smartpayAccount.iuguAccountInfo.cep.replace(/[-]/g, '')
                : smartpayAccount.iuguAccountInfo.cep,
              address: smartpayAccount.iuguAccountInfo.address,
              addressNumber: smartpayAccount.iuguAccountInfo.addressNumber,
              state: {
                ...smartpayAccount.iuguAccountInfo.state,
                value: smartpayAccount.iuguAccountInfo.state
                  ? smartpayAccount.iuguAccountInfo.state.id
                  : 0,
                label: smartpayAccount.iuguAccountInfo.state
                  ? smartpayAccount.iuguAccountInfo.state.name
                  : '',
              },
              city: {
                ...smartpayAccount.iuguAccountInfo.city,
                value: smartpayAccount.iuguAccountInfo.city
                  ? smartpayAccount.iuguAccountInfo.city.id
                  : 0,
                label: smartpayAccount.iuguAccountInfo.city
                  ? smartpayAccount.iuguAccountInfo.city.name
                  : '',
              },
              phone: smartpayAccount.iuguAccountInfo.telephone
                ? smartpayAccount.iuguAccountInfo.telephone.replace(
                    /[()/-]/g,
                    ''
                  )
                : smartpayAccount.iuguAccountInfo.telephone,
            });
            setFormSmartPay(true);
          }
        } else {
          showNotificationAutoDestroy(
            'danger',
            t('notifications.error'),
            t('notifications.record-not-found')
          );
          backClickHandler();
        }
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('notifications.find-record-error')
        );
      })
      .finally(() => {
        hideLoading();
      });
  }

  const handleSubmit = (values) => {
    const mutation = accountSaveMutation(values);
    showLoading();
    GraphQL(mutation, {})
      .then(() => {
        backClickHandler();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('notifications.find-record-error')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  function mediatorForm() {
    if (formSmartPay) {
      return (
        <SmartPayForm
          onSubmit={handleSubmit}
          backHandler={backClickHandler}
          dto={dto}
          showLoading={showLoading}
          hideLoading={hideLoading}
          history={history}
        />
      );
    }
    return (
      <AccountForm
        onSubmit={handleSubmit}
        backHandler={backClickHandler}
        dto={dto}
        showLoading={showLoading}
        hideLoading={hideLoading}
        history={history}
      />
    );
  }

  useEffect(() => {
    if (match.params.id && match.params.id > 0) {
      if (dto.id !== parseInt(match.params.id, 0)) {
        findById(match.params.id);
      } else {
        setFormOn(true);
      }
    } else {
      setFormOn(true);
    }
  }, [dto]);

  return (
    <SmartCard title={t('panels.conta')}>
      {formOn ? mediatorForm() : null}
    </SmartCard>
  );
};

AccountFormHandler.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(AccountFormHandler)
);
